import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, setUserToken } from "../lib/api";

const AuthContext = createContext({ user: null, loading: true });

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem("c4t_user_token");
    if (!token) { setUser(null); setLoading(false); return; }
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      setUser(null);
      setUserToken(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (typeof window !== "undefined" && (window.location.hash?.includes("session_id=") || window.location.hash?.includes("id_token="))) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const login = () => {
    const redirectUri = window.location.origin + "/auth/callback";
    const nonce = Math.random().toString(36).slice(2);
    const params = new URLSearchParams({
      client_id: "37446752834-u24ppuk374s6m1f07n1hg2qq6q4g2fmn.apps.googleusercontent.com",
      redirect_uri: redirectUri,
      response_type: "id_token",
      scope: "openid email profile",
      nonce,
    });
    window.location.href = "https://accounts.google.com/o/oauth2/v2/auth?" + params.toString();
  };

  const emailLogin = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setUserToken(r.data.session_token);
    setUser({ user_id: r.data.user_id, email: r.data.email, name: r.data.name, picture: r.data.picture });
    return r.data;
  };

  const emailRegister = async (email, password, name) => {
    const r = await api.post("/auth/register", { email, password, name });
    setUserToken(r.data.session_token);
    setUser({ user_id: r.data.user_id, email: r.data.email, name: r.data.name, picture: r.data.picture });
    return r.data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    setUserToken(null);
    setUser(null);
    window.location.href = "/";
  };

  const deleteAccount = async () => {
    await api.delete("/auth/account");
    setUserToken(null);
    setUser(null);
    window.location.href = "/";
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, emailLogin, emailRegister, logout, deleteAccount, refresh: checkAuth, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
